import { render, staticRenderFns } from "./updateTemplate.vue?vue&type=template&id=54a22a1a&scoped=true"
import script from "./updateTemplate.vue?vue&type=script&lang=js"
export * from "./updateTemplate.vue?vue&type=script&lang=js"
import style0 from "./updateTemplate.vue?vue&type=style&index=0&id=54a22a1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a22a1a",
  null
  
)

export default component.exports